module.exports = __webpack_public_path__ + "img/selected-leaves-in-the-wind.645f122a.webp";